import { useState } from "react";
import Card from "../components/Card";
import EmptyState from "../components/EmptyState";
import ClubRow from "../components/ClubRow";
import { Oro } from "../components/Oro";

export default function UiPlayground() {
  const [motionEnabled, setMotionEnabled] = useState(true);

  return (
    <div className="min-h-screen bg-oro-bg text-oro-text-primary">
      <div className="mx-auto max-w-5xl px-page-x py-page-y space-y-12">
        {/* Hero Header */}
        <header className="text-center space-y-6">
          <div className="flex justify-center">
            <Oro size="lg" animated={motionEnabled} />
          </div>
          <div className="space-y-3">
            <p className="text-xs uppercase tracking-[0.4em] text-oro-gold-text font-medium">
              The Oro Design System
            </p>
            <h1 className="text-4xl font-bold tracking-tight text-oro-text-primary">
              Your presence made visible
            </h1>
            <p className="text-lg text-oro-text-secondary max-w-2xl mx-auto leading-relaxed">
              A comprehensive design system showcasing the Nightfall aesthetic with breathing animations, 
              refined typography, and gold accents that embody the ORO MOVE<sup>™</sup> experience.
            </p>
          </div>
        </header>

      {/* List pattern */}
      <section className="space-y-4">
        <h2 className="text-sm font-semibold tracking-tight text-oro-text-secondary">
          List Components
        </h2>
        
        {/* Club List Example */}
        <div className="space-y-2">
          <h3 className="text-xs font-medium text-oro-text-muted uppercase tracking-wide">Club Rows</h3>
          <Card variant="list">
            <ClubRow
              name="River Valley Runners"
              description="A community for runners of all levels in the river valley area"
              memberCount={32}
              upcomingEventCount={3}
              role="leader"
            />
          </Card>
        </div>

        {/* Motion Control */}
        <div className="flex items-center gap-3">
          <label className="text-sm font-medium text-oro-text-primary">
            Enable Motion
          </label>
          <button
            onClick={() => setMotionEnabled(!motionEnabled)}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
              motionEnabled ? 'bg-oro-gold' : 'bg-oro-border'
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                motionEnabled ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
          <span className="text-sm text-oro-text-muted">
            {motionEnabled ? 'Enabled' : 'Disabled'}
          </span>
        </div>
      </section>

      {/* Empty States */}
      <section className="space-y-4">
        <h2 className="text-sm font-semibold tracking-tight text-oro-text-secondary">
          Empty States
        </h2>
        <div className="grid gap-4 md:grid-cols-2">
          <EmptyState
            icon="📋"
            title="No check-ins yet"
            message="Members will appear here as soon as they check in to your event."
          />
          
          <EmptyState
            icon="🏃‍♂️"
            title="No clubs yet"
            message="Join your first club to start tracking workouts and connecting with others."
            actionLabel="Browse Clubs" onAction={() => {/* Demo action - no operation */}}
          />
        </div>
      </section>
      </div>
    </div>
  );
}